

















import Vue from 'vue'
import { Component, Emit, Prop } from 'vue-property-decorator'

import { SelectOption } from "../../../logic/types";
import { ChipsWithSelectData } from "../../Pi/fields/ChipsInput/types";
import ChipsTag from './ChipsTag.vue'

@Component({
  components: {
    ChipsTag
  }
})
export default class ChipsTags extends Vue {
  @Prop({ type: Array, default: () => [] }) tags!: Array<string | number>

  @Prop({ type: Boolean, default: false, required: false }) disabled!: boolean

  @Prop() options!: Array<SelectOption | string>

  @Prop() formatter!: ChipsWithSelectData['formatter']

  @Emit()
  removeWord(word: string | number) {
    return word
  }

  checkLabel(value: string | number) {
    if (this.options) {
      if (typeof this.options[0] === 'string') {
        return value
      } else {
        const option = this.options.find(o => typeof o !== 'string' && o.value === value)

        if (option && typeof option !== 'string') {
          return option.label
        } else {
          return value
        }
      }
    }

    return value
  }
}
